module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"toAccount":"Back to account"}}')
  delete Component.options._Ctor
}
